function Stars() {
  return (
    <div className="flex items-center gap-0.5">
      {[1,2,3,4,5].map(i => <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>)}
    </div>
  );
}

const testimonials = [
  {
    text: "We planned a ski trip to Switzerland from Jackson Hole and realized our passports were about to expire. Fast Passport Center had both renewed in 7 days. Absolute lifesavers — the trip was incredible.",
    name: "Ryan & Claire S.",
    location: "Jackson, WY",
    service: "Renewal",
  },
  {
    text: "I needed an emergency passport after mine was stolen in Jackson. Fast Passport Center handled DS-64, DS-11, and everything — new passport arrived in 3 days. I made my flight to Costa Rica.",
    name: "Alex B.",
    location: "Teton Village, WY",
    service: "Emergency Replacement",
  },
  {
    text: "We do a lot of international travel for business from Jackson Hole. FPC got me a second passport in under 10 days. Their agent was responsive, knowledgeable, and made the whole process completely painless.",
    name: "Patricia H.",
    location: "Jackson Hole, WY",
    service: "Second Passport",
  },
];

export default function TestimonialsSection() {
  return (
    <section id="reviews" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Jackson Hole Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Jackson and Teton County travelers who trusted Fast Passport Center to handle their passport applications.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col">
              <Stars />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">&ldquo;{t.text}&rdquo;</p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}